import actionTypes from "data/actions/actionTypes";
import Constants from "data/constants";

const initialState = {
    cards: [],
    status: Constants.NONE,
};

const cardsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CARDS_FETCH_REQUESTED:
            return { ...state, ...action.payload };
        case actionTypes.CARDS_FETCH_RESULT:
            return { ...state, ...action.payload };
        /* istanbul ignore next */
        case actionTypes.PERSIST_PURGE:
            return initialState;
        default:
            return state;
    }
};

export default cardsReducer;

export const cardsStatusSelector = (state: Object) => state.cards.status;
export const cardsCardsSelector = (state: Object) => state.cards.cards;
